/**
 * @generated SignedSource<<35244fb25e6e53ed35c17251a8e6bb8f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductVideo_viewer$data = {
  readonly video: {
    readonly fileByVideoSize: {
      readonly link: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "ProductVideo_viewer";
};
export type ProductVideo_viewer$key = {
  readonly " $data"?: ProductVideo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductVideo_viewer">;
};

import ProductVideoRefetchQuery_graphql from './ProductVideoRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": ProductVideoRefetchQuery_graphql
    }
  },
  "name": "ProductVideo_viewer",
  "selections": [
    {
      "alias": "video",
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "concreteType": "VideoVimeo",
      "kind": "LinkedField",
      "name": "itemVideo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VideoVimeoFile",
          "kind": "LinkedField",
          "name": "fileByVideoSize",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "00dacb5f943de344cd0d9a656feb95d8";

export default node;
